/***
 * @file: åæ¢è´¦æ·
 * @author: linkun.he
 * @Date: 2020-01-03 11:37:15
 *
 * What should you do in a project
 *   1. Turn hideChangeAccount to false in app.config.ts
 *   2. Import `AccountChangeTurningComponent` from `@ithinkdt/pages` and config routing `change-account` for the  `AccountChangeTurningComponent` in the root
 */
import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { NzMessageService } from 'ng-zorro-antd';

import { SettingsService } from '@ithinkdt/shared/browser';
import { I18NService } from '@ithinkdt/shared/i18n';
import { preventBubble } from '@ithinkdt/shared/utils';
import { API, ChangeAccountService } from '@ithinkdt/theme/fetch-service';
import { AccountInfo } from '@ithinkdt/theme/models';

import { DEFAULT_USER_AVATAR } from './default-user-avatar';

@Component({
  selector: 'dt-change-account',
  templateUrl: './change-account.component.html',
  styleUrls: ['./change-account.component.scss'],
})
export class ChangeAccountComponent {
  // æ¯å¦æ¾ç¤ºå¼¹æ¡
  isVisible = false;
  // ç§æ·ä¿¡æ¯åè¡¨
  accountList: AccountInfo[] = [];
  // æå­ç§æ·Id
  temporaryTenantId: any;

  constructor(
    private changeAccountSrv: ChangeAccountService,
    private messageSrv: NzMessageService,
    private i18nSrv: I18NService,
    private router: Router,
    private settingsSrv: SettingsService
  ) {}

  open() {
    this.isVisible = true;
    this.getAccountList();
  }

  // è¿å»ç§æ·åè¡¨æ°æ®
  getAccountList() {
    this.changeAccountSrv.getAccountList().subscribe((res) => {
      if (res.status) {
        this.accountList = this.handleNoSelectId(res.data);
      }
    });
  }

  // åæ¢è´¦å·çå¤ç
  handleNoSelectId(data) {
    data.map((t) => {
      t.logo = t.logo
        ? `${this.settingsSrv.userConfig.env.serverName.file}${API.downloadImageByPubUrl}${t.logo}`
        : DEFAULT_USER_AVATAR;
    });
    return data;
  }

  // è®¾ç½®é»è®¤è´¦æ·
  settingDefult(data, evt) {
    this.changeAccountSrv.settingDefaultAccount({ tenantId: data.tenantId }).subscribe((res) => {
      if (res.status) {
        this.messageSrv.success(this.i18nSrv.interpret('account.settingSuccess'));
        this.getAccountList();
      }
    });
    // é²æ­¢åæ³¡
    preventBubble(evt);
  }

  // åæ¢è´¦æ·
  exchangeAccount(index) {
    this.accountList.map((t, i) => {
      if (index === i) {
        t.selected = true;
        this.temporaryTenantId = t.tenantId;
      } else {
        t.selected = false;
      }
    });
  }

  // åæ¶äºä»¶
  close() {
    this.isVisible = false;
  }

  // ç¡®å®äºä»¶
  handleOk() {
    const selected = this.accountList.filter((t) => {
      if (t.selected) {
        return t.tenantName;
      }
    });
    this.changeAccountSrv.exchangeAccount({ tenantId: this.temporaryTenantId }).subscribe((res) => {
      if (res.status) {
        this.messageSrv.success(this.i18nSrv.interpret('account.exchangeSuccess'));
        this.close();
        this.router.navigate(['/change-account'], { queryParams: { token: res.data } });
      }
    });
  }
}
